import type { Environment } from './models';
import { validateRuntimeEnvironment } from './runtime-env-guards';

/**
 * Validates Tier 1 (critical) environment configuration before Angular bootstrap.
 * Throws an error with details if validation fails.
 *
 * @param env - The environment object to validate
 * @throws Error if critical environment configuration errors are detected
 */
export function validateEnvironmentBeforeBootstrap(env: Environment): void {
    const tier1Result = validateRuntimeEnvironment(env);

    if (tier1Result.criticalErrors.length === 0) return;

    const isEnvDefinedAndNonProd =
        env.env === 'development' || env.env === 'qa' || env.env === 'uat';

    const criticalErrorsList = tier1Result.criticalErrors
        .map((err) => '  - ' + err)
        .join('\n');
    const errorMessage =
        'Critical environment configuration errors detected' +
        (isEnvDefinedAndNonProd ? ':\n' + criticalErrorsList : '');

    console.error(errorMessage);
    throw new Error(errorMessage);
}
